import { render, staticRenderFns } from "./Flechas-componente.vue?vue&type=template&id=49227a16&scoped=true&"
import script from "./Flechas-componente.vue?vue&type=script&lang=js&"
export * from "./Flechas-componente.vue?vue&type=script&lang=js&"
import style0 from "./Flechas-componente.vue?vue&type=style&index=0&id=49227a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49227a16",
  null
  
)

export default component.exports